import { Action } from 'redux'
import * as Actions from './actionTypes'
import { buildErrorAction, ErrorAction } from 'src/common/apiLoader/state/actions'
import { DashboardData } from 'src/common/models/report'

export interface GetDashboardDataAction extends Action {
    dateFrom: string
    dateTo: string
}
export interface GetDashboarDataSuccessAction extends Action {
    dashboardData: DashboardData
}
export const getDashboardDataApi = (dateFrom: string, dateTo: string): GetDashboardDataAction => ({
    type: Actions.GET_DASHBOARD_DATA_API,
    dateFrom,
    dateTo,
})
export const getDashboardDataApiSuccess = (dashboardData: DashboardData): GetDashboarDataSuccessAction => ({
    type: Actions.GET_DASHBOARD_DATA_API_SUCCESS,
    dashboardData,
})
export const getDashboardDataApiError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_DASHBOARD_DATA_API_ERROR,
    error,
)